<script>
  import { onMount, onDestroy } from "svelte";
  import { slide } from "svelte/transition";
  import Checkbox from "../Common/Checkbox.svelte";
  import {External, M} from "../external";

  export let property;

  let textarea, jTextArea;

  $: {
    if (property.id == 0)
      property.name = External.Tools.urlFromString(
        property.label || "",
        true,
        true,
        "_"
      ).toLowerCase();
  }

  let onDelete = idx => {
    property.value.splice(idx, 1);
    property.value = property.value;
  };

  let addOption = () => {
    if (!property.value) {
      property.value = [M.OPTION];
    } else {
      property.value.push(M.OPTION);
      property.value = property.value;
    }
  };

  export const getData = () => {
    property.description = External.Tools.getTextEditorValue(jTextArea);
    return property;
  };

  onMount(() => {
    jTextArea = External.$(textarea);
    External.Tools.addTextEditor({
      element: jTextArea,
      addLinkButton: true,
      hasPersonalizationTags: false,
      isMinimalistic: true
    });
  });

  onDestroy(() => {
    External.Tools.removeTextEditor(jTextArea);
  });
</script>

<div class="popup-widget-wrapper">
  {#if property.id != 0}
    <div class="col20 f-left mb-15">
      <h4
        class="members-title f-left col20 roboto t-left"
        style="font-size: 26px;">
        {property.label}
      </h4>
      <span class="explain-text ta-left f-left col20 Roboto mt-10 f-13n">
        {M.CREATED}:
        <b data-role="created">{property.createdOn}</b>
      </span>
    </div>
  {/if}
  <div class="col20 f-left mt-15">
    <div class="info">
      <h5>{M.LABEL}</h5>
      <span>{M.PROPERTY_LABEL_DESC}</span>
    </div>
    <div class="right-side">
      <input
        type="text"
        class="transition-border"
        bind:value={property.label} />
    </div>
    <div
      class="col20 f-left cpanel-tooltip"
      data-tooltip="crmAttributeInternalName"
      style="padding: 5px 0;">
      {M.INTERNAL_NAME} -
      <b data-role="name">{property.name}</b>
    </div>
  </div>
  <div class="col20 f-left mt-15" style="overflow: visible">
    <div class="info">
      <h5>{M.DESCRIPTION}</h5>
      <span>{M.PROPERTY_DESCRIPTION}</span>
    </div>
    <div class="rich-text-area f-left col20 mt-5">
      <textarea bind:this={textarea}>{property.description || ''}</textarea>
    </div>
  </div>
  <div class="col20 f-left mt-15">
    <div class="info">
      <h5>{M.FIELD_TYPE}</h5>
      <span>{M.FIELD_TYPE_DESC}</span>
    </div>
    <div class="right-side">
      <select class="transition-border" bind:value={property.type}>
        <option value="STRING">{M.SINGLE_LINE}</option>
				<option value="EMAIL">{M.EMAIL}</option>
				<option value="PHONE">{M.PHONE}</option>
        <option value="NUMBER">{M.NUMBER}</option>
        <option value="BOOLEAN">{M.TRUE_FALSE}</option>
        <option value="DATE">{M.DATE}</option>
        <option value="LIST">{M.LIST}</option>
      </select>
    </div>
  </div>
  {#if property.type === 'LIST'}
    <div class="col20 f-left" transition:slide|local={{ duration: 200 }}>
      <div class="info mt-15">
        <h5>{M.LIST_VALUES}</h5>
        <span>{M.LIST_VALUES_DESC}</span>
        {#each property.value || [] as val, idx (idx)}
          <div class="option-wrapper field col20 f-left flex align-center">
            <input type="text" bind:value={val} />
            <div class="buttons-wrapper flex align-center">
              <a
                data-tooltip="simpleDelete"
                class="delete delete-icon modify button-tooltip light-gray-icon
                circle-effect ml-5"
                on:click={() => onDelete(idx)}>
                 <i class="material-icons-outlined">delete</i>
              </a>
            </div>
          </div>
        {/each}
        <a class="add-option blue ml-0" on:click={addOption}>{M.ADD_OPTION}</a>
      </div>
    </div>
  {/if}

  <Checkbox
    bind:data={property.publicProperty}
    label={M.AVAILABLE_IN_FORMS}
    description={M.AVAILABLE_IN_FORMS_DESC} />

</div>
